import React from 'react';
import APInput from 'apex-web/lib/components/common/APInput';
import APNumberInput from 'apex-web/lib/components/common/APNumberInput';
import APSelect from '../components/common/APSelect';
import APLabelWithText from 'apex-web/lib/components/common/APLabelWithText';
import { required, biggerThanZero } from 'apex-web/lib/helpers/formValidations';
import WhiteListedWithdrawAddressSelectContainer from '../components/WhiteListedWithdrawAddressSelect/WhiteListedWithdrawAddressSelectContainer';

export const fieldToLabel = field => field.replace(/([a-z])([A-Z])/g, '$1 $2');

const noValidationFields = ['DestinationTagNumber', 'Comment', 'TemplateType'];

export const templateFormRenderer = (
  template,
  customClass,
  context,
  { Product, ProductSymbol, DecimalPlaces } = {},
  verificationLevelConfig = {}
) =>
  Object.keys(template).map(field => {
    const label =
      field === 'BankAccountName'
        ? context.t('Bank Name')
        : context.t(fieldToLabel(field));
    const validate = noValidationFields.includes(field) ? null : required;
    const type = field === 'TemplateType' ? 'hidden' : 'text';

    if (template[field] && template[field].indexOf('[') === 0) {
      let options = template[field].split(',').map(el => {
        const value = el.trim().replace(/[[\]]/g, '');
        return { value, label: value };
      });

      if (field === 'Country') {
        try {
          const parsedArray = JSON.parse(template[field]);
          options = parsedArray.map(el => ({
            value: el.Code,
            label: el.Name
          }));
        } catch (e) {
          // do nothing
        }
      }

      return (
        <APSelect
          key={field}
          name={field}
          customClass={customClass}
          data-test={field}
          label={label}
          validate={[required]}
          options={options}
        />
      );
    }

    if (field === 'ExternalAddress') {
      if (verificationLevelConfig.RequireWhitelistedAddress) {
        return <WhiteListedWithdrawAddressSelectContainer key={field} />;
      }

      return (
        <APCryptoAddressInputContainer
          productSymbol={Product || ProductSymbol}
          key={field}
          name={field}
          data-test={field}
          customClass={customClass}
          label={label}
        />
      );
    }
    if (template[field] && field !== 'TemplateType') {
      return (
        <APLabelWithText
          key={field}
          data-test={field}
          label={`${context.t(label)}:`}
          text={template[field]}
          customClass={customClass}
          classModifiers="template-info"
        />
      );
    } else {
      if (field === 'DestinationTagNumber') {
        return (
          <APNumberInput
            key={field}
            type="text"
            name="DestinationTagNumber"
            label={context.t('Destination Tag Number')}
            decimalPlaces={0}
            customClass={customClass}
            info={context.t(
              'Please note that a destination tag may be required if you are withdrawing to an exchange or online wallet.'
            )}
            allowBigNumber
            validate={validate}
          />
        );
      }

      if (field.toLowerCase() === 'amount') {
        return (
          <APNumberInput
            key={field}
            type="text"
            name="Amount"
            labelInInput={Product || ProductSymbol}
            label={context.t(`Amount of ${Product || ProductSymbol}`)}
            decimalPlaces={DecimalPlaces}
            customClass={customClass}
            validate={[required, biggerThanZero]}
          />
        );
      }

      return (
        <APInput
          key={field}
          name={field}
          data-test={label}
          customClass={customClass}
          label={label}
          type={type}
          validate={validate}
        />
      );
    }
  });

export const templateConfirmRenderer = (
  template,
  values,
  classNames,
  context
) => {
  return Object.keys(template || {}).map(field => (
    <APLabelWithText
      label={
        field === 'BankAccountName'
          ? context.t('Bank Name')
          : context.t(fieldToLabel(field))
      }
      key={field}
      data-test={field}
      text={values[field]}
      customClass={classNames()}
    />
  ));
};
